import ContractPrint from './ContractPrint';

export default ContractPrint;
